"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Ly = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 960 480", ...props },
    react_1.default.createElement("path", { fill: "#239e46", d: "M0 0h960v480H0z" }),
    react_1.default.createElement("path", { d: "M0 0h960v360H0z" }),
    react_1.default.createElement("path", { fill: "#e70013", d: "M0 0h960v120H0z" }),
    react_1.default.createElement("circle", { cx: 480, cy: 240, r: 60, fill: "#fff" }),
    react_1.default.createElement("circle", { cx: 492.132, cy: 240, r: 52.132 }),
    react_1.default.createElement("path", { fill: "#fff", d: "m509.175 240 80.7-26.221L540 282.426v-84.852l49.875 68.647z" })));
exports.default = Ly;
//# sourceMappingURL=Ly.js.map